export const VirusMonitorEvents = {
  virusMonitorSyncStatusUpdated: 'Arable_VirusMonitorCalculationStatusUpdated',
}

export interface VirusMonitorSyncStatusUpdatedEvent {
  CustomerId: number;
  CropFieldId: number;
  Status: 'Initiated' | 'Completed' | 'Failed';
  CalculationTaskCode: string;
  Timestamp: Date;
}
